package com.solevo.dist.network.api.customers

import com.solevo.dist.application.models.Customer
import com.solevo.dist.network.infrastructure.utils.DefaultRemoteSourceImplementationException
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow

interface CustomerRemoteSource {
    fun currentCustomer(): Flow<Customer?> = flow { throw DefaultRemoteSourceImplementationException() }
    suspend fun customer(): Result<Customer?> = Result.failure(DefaultRemoteSourceImplementationException())

}